import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-orange-900 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2">
              <div className="rounded-xl border border-white/10 bg-white/5 p-1 shadow-lg">
                <img
                  src="/logo.png"
                  alt="The Alpha Consult logo"
                  className="h-10 w-10 rounded-lg object-cover md:h-11 md:w-11"
                />
              </div>
              <div>
                <div className="text-lg font-nunito">The Alpha Consult</div>
                <div className="text-sm text-orange-300 font-nunito">Alpha Consulting LLC</div>
              </div>
            </div>
            <p className="mt-3 text-sm text-orange-300 font-nunito">
              Product engineering for teams that want reliability, speed, and craft.
            </p>
          </div>

          <div>
            <h4 className="font-semibold font-nunito">Company</h4>
            <ul className="mt-3 space-y-2 text-sm">
              <li>
                <Link to="/" className="text-orange-300 hover:text-white transition-colors font-nunito">
                  Overview
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-orange-300 hover:text-white transition-colors font-nunito">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/process" className="text-orange-300 hover:text-white transition-colors font-nunito">
                  Process
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-orange-300 hover:text-white transition-colors font-nunito">
                  Plans
                </Link>
              </li>
              <li>
                <Link to="/atlanta-software-development" className="text-orange-300 hover:text-white transition-colors font-nunito">
                  Atlanta Software
                </Link>
              </li>
              <li>
                <Link to="/georgia-cloud-consulting" className="text-orange-300 hover:text-white transition-colors font-nunito">
                  Georgia Cloud
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold font-nunito">Get in touch</h4>
            <ul className="mt-3 space-y-2 text-sm">
              <li>
                <a
                  href="mailto:info@thealphaconsult.com"
                  className="text-orange-300 hover:text-white transition-colors font-nunito"
                >
                  info@thealphaconsult.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex items-center justify-between gap-4 text-sm text-orange-400 flex-wrap">
          <p className="font-nunito">
            {'\u00A9'} {currentYear} Alpha Consulting LLC. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <Link to="/privacy" className="hover:text-white transition-colors font-nunito">
              Privacy
            </Link>
            <Link to="/privacy" className="hover:text-white transition-colors font-nunito">
              Terms
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
